import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';

import Bs4GenericField from './Bs4GenericField'
import Bs4MainDispatch from '../../Bs4MainDispatch';

export default class Bs4Info extends Bs4GenericField {

  //hesValue () {return false;}
  
  ViewComponentField = (props) => {
    const formField = this;
    this.refFocus = React.useRef();
    const [value, setValue] = React.useState(() => this.getValue());

    React.useEffect(() => {
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue());
      })    
    }, []);

    const handleClick = (event) => {
      console.log('... click...', value)
      Bs4MainDispatch.commandParserAfter(this.bs4KartotekaId)
    } 
    
    return (
      <FormControl fullWidth >
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Box ref={this.refFocus} dangerouslySetInnerHTML={{__html:value}} onClick={handleClick} />
      </FormControl>
    );
  }
}